import { render, staticRenderFns } from "./step5.vue?vue&type=template&id=6b0a4360&scoped=true"
import script from "./step5.vue?vue&type=script&lang=js"
export * from "./step5.vue?vue&type=script&lang=js"
import style0 from "./step5.vue?vue&type=style&index=0&id=6b0a4360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0a4360",
  null
  
)

export default component.exports